var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"irisLottieAnimationContainer",style:(_vm.style),attrs:{"alt":_vm.alt,"role":"img","aria-hidden":_vm.isAriaHidden ? 'true' : null}})
}
var staticRenderFns = []

export { render, staticRenderFns }